import { withAuthenticationRequired } from '@auth0/auth0-react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import CalendarLayoutSettings from '@app/pages/settings/CalendarLayoutSettings.tsx';
import Intro from '@app/layout/Intro.tsx';
import React from 'react';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';
import { PermissionTypesEnum } from '@api/ringil-api.v2.tsx';

const CalendarLayoutPage = () => {
  const { tr } = useTranslationLgs();

  return (
    <ResponsiveLayout
      title={tr(`CalendarLayout.pageTitle`, `Calendar card layouts`)}
      oneOfPermission={[PermissionTypesEnum.PERMISSION_CALENDAR_LAYOUT_READ, PermissionTypesEnum.PERMISSION_CALENDAR_LAYOUT_RW]}
    >
      <CalendarLayoutSettings />
    </ResponsiveLayout>
  );
};

export default withAuthenticationRequired(CalendarLayoutPage, {
  onRedirecting: () => <Intro />,
});
